import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChevronLeft } from "lucide-react";
import { API } from "@/constants";
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";

const InvestigationServicesPage = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/services/investigations/services`);
        setServices(res.data.services || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);
  
  return (
    <main className="min-h-screen bg-slate-50" data-testid="investigation-services-page">
      <Disclaimer />
      <div className="container-shell py-8 max-w-6xl">
        <div className="mb-6">
          <Link to="/tools/services-hub" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1 mb-4">
            <ChevronLeft className="h-4 w-4" /> Back to Services Hub
          </Link>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Fraunces', serif" }}>Investigation Services</h1>
          <p className="text-muted-foreground">Licensed investigators nationwide - background to deep surveillance</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-4">
          {services.map((svc, i) => (
            <Card key={i} className={svc.included_with_premium ? "border-emerald-300 bg-emerald-50" : ""}>
              <CardContent className="p-5">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="font-semibold">{svc.name}</h3>
                  {svc.included_with_premium ? (
                    <Badge className="bg-emerald-600">INCLUDED</Badge>
                  ) : (
                    <Badge variant="outline">${svc.price}</Badge>
                  )}
                </div>
                <p className="text-sm text-muted-foreground mb-3">Turnaround: {svc.turnaround} days</p>
                <Button size="sm" className="w-full" variant={svc.included_with_premium ? "default" : "outline"}>
                  Request Investigation
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
};


export default InvestigationServicesPage;
